export const de = {
    "TRIGGER_LISTEN": "Hören auf Auslöser",
    "ASSIST_EMPTY_MSG": "Agent AI hört aktiv zu und ist bereit, automatisch zu assistieren, wenn ausgelöst.",
    "MYBOT_TRIGGET_LISTEN": "Aktuell keine My Bot-Aufgaben vorhanden",
    "MYBOT_EMTPY_MSG": "Um eine Aufgabe in My Bot zu starten, gehen Sie zum Suchtab und wählen Sie die Option \"Mit Agenteneingaben ausführen\" für die gewünschte Aufgabe.",
    "PROACTIVE_MODE": "Proaktiver Modus",
    "SETTINGS": "Einstellungen",
    "HELP_AND_SUPPORT": "Hilfe und Support",
    "HELP": "Hilfe",
    "LANGUAGE": "Sprache",
    "THEME": "Design",
    "AUTOMATIC": "Automatisch",
    "DARK": "Dunkel",
    "LIGHT": "Hell",
    "THEME_DESC": "Dies wird Ihren Systemstandardmodus verwenden.",
    "DOCUMENTATION": "Dokumentation",
    "DOC_DESC": "Lesen Sie unsere umfassenden Dokumentationsartikel.",
    "FAQ_U": "FAQ",
    "FAQ_DESC": "Häufig gestellte Fragen zu Agent AI anzeigen.",
    "KORE_ACADEMY": "Kore Academy",
    "FILE_NAME":"Dateiname",
    "ASK_A_QUESTION":"Stelle eine Frage",
    "KORE_ACA_DESC": "Erfahren Sie mehr über Agent AI, indem Sie die Akademiekurse durchgehen.",
    "SEARCH": "Suchen",
    "AUTO_SCROLL_TOOLTIP":"Steuert das automatische Scrollen des Assistenz-Tabs, meines Bots und der Transkript-Tab-Inhalte",
    "MY_BOT": "Mein Bot",
    "PLAYBOOK": "Spielbuch",
    "AUTOSCROLL_ASSIST":"Automatisches Scrollen Unterstützung",
    "TAP_SEARCH":"Tippen Sie auf „Suchen“.",
    "TAB_TEXT":"Keine Tabs aktiviert! Bitte aktivieren Sie mindestens einen Tab",
    "ASSIST": "Assistieren",
    "TRANSCRIPT": "Transkript",
    "HISTORY": "Verlauf",
    "STARTOVER": "Neustart",
    "RESTART_INPUTS": "Neustart mit erfassten Eingaben",
    "ASKCUSTOMER": "Frage den Kunden",
    "TELLCUSTOMER": "Sage dem Kunden",
    "WELCOME_MSG": "Willkommensnachricht",
    "SEND": "Senden",
    "SENT": "Gesendet",
    "AWAITING": "Warten auf Antwort | Tippen Sie, um fortzufahren",
    "OVERRIDE": "Tippen Sie, um fortzufahren",
    "ACCEPT_RESPONSE": "Antwort akzeptiert",
    "AGENT_ENTERED": "Agent betreten",
    "EXPECTED_FORMAT": "Erwartetes Format",
    "INPUT_VALUES": "Eingabewerte",
    "RESTART": "Neustart",
    "START_OVER": "Von vorne beginnen",
    "RESTART_CAPTURE": "Neustart mit erfassten Eingaben",
    "CANCEL": "Abbrechen",
    "INTERRUPT_DIALOG": "UNTERBROCHENE DIALOGAUFGABE",
    "RUN": "AUSFÜHREN",
    "RUN_AGENT": "Mit Agenteneingabe ausführen",
    "STEP": "Schritt",
    "DIALOG_TASK": "Dialogaufgabe",
    "FAQ": "FAQ",
    "SNIPPET": "Antworten",
    "ARTICLE": "Webseiten",
    "FILE": "Dateien",
    "SUGGESTED": "Vorgeschlagen",
    "ALL_DIALOG": "Alle Dialogaufgaben",
    "DIALOG_TEXT": "Dialog",
    "INTENT_IDENTIFIED": "Kundenäußerung",
    "NOT_WHAT_LOOKING": "Falscher Vorschlag?",
    "BOT": "Bot",
    "CUSTOMER": "Kunde",
    "YOU": "Du",
    "TERMINATE_CONV": "Dialogaufgabe beenden",
    "TERMINATE_CONV_DESC": "Sind Sie sicher, dass Sie die Dialogaufgabe beenden möchten? Agent AI kann keine Vorschläge mehr machen.",
    "YES_TERMINATE": "Ja, beenden",
    "NO_CANCEL": "Nein, abbrechen",
    "OVERRIDE_CONTINUE": "Fortsetzen im Überschreibungsmodus",
    "SUMMARY_TEXT": "Zusammenfassung",
    "SUBMIT": "Einreichen",
    "INTERRUPT_OCCURED": "Unterbrechung aufgetreten",
    "IDENTIFIED_INTENT": "Erkannte Absicht",
    "INTERRUPT_DESC": "Das Ausführen würde Ihre laufende Dialogaufgabe beenden.",
    "ACCEPT_RUN": "Akzeptieren und ausführen",
    "RUN_LATER": "Später ausführen",
    "KNOW_MORE": "Mehr erfahren",
    "MORE_TEXT": "Mehr",
    "LESS_TEXT": "Weniger",
    "VIEW_MORE": "Mehr anzeigen",
    "VIEW_LESS": "Weniger anzeigen",
    "SHOW_MORE_FAQ": "Mehr FAQs anzeigen",
    "SHOW_LESS_FAQ": "Weniger FAQs anzeigen",
    "SHOW_MORE_ARTICLE": "Mehr Webseiten anzeigen",
    "SHOW_LESS_ARTICLE": "Weniger Webseiten anzeigen",
    "SHOW_MORE_SNIPPET": "Mehr Antworten anzeigen",
    "SHOW_LESS_SNIPPET": "Weniger Antworten anzeigen",
    "SHOW_MORE_FILES": "Mehr Dateien anzeigen",
    "SHOW_LESS_FILES": "Weniger Dateien anzeigen",
    "VIEW_ALL_DIALOG": "Alle Dialoge anzeigen",
    "VIEW_FEW_DIALOG": "Einige Dialoge anzeigen",
    "HELP_FULL": "Hilfreich?",
    "THANKYOU": "Danke!",
    "EXPAND_MORE": "Mehr anzeigen \/ Mehr",
    "CLOSE_TEXT": "Schließen",
    "STARTED": "Gestartet",
    "ENDED": "Beendet",
    "VIEW_FULL_ARTICLE": "Webseite anzeigen",
    "VIEW_FULL_FILE": "Datei anzeigen",
    "COPIED": "Kopiert",
    "SENTI_ANALY": "Stimmungsanalyse",
    "WRONG_SUGGESTION": "Falsche Vorschläge",
    "INCORRECT_INTENT": "Falsche Absicht",
    "ACCIDENTAL_CLICK": "Versehentlicher Klick",
    "TIME_TAKING": "Zeitaufwendig",
    "OTHER": "Andere",
    "PLAYBOOK_EMPTY_MSG": "Wählen Sie ein Playbook aus",
    "PLAYBOOK_EMPTY_DESC": "Agent AI kann das Playbook nicht laden, da alle verfügbaren Playbooks dynamisch sind. Klicken Sie auf \"Playbook auswählen\", um auf das Playbook zuzugreifen.",
    "STAGE": "Bühne",
    "PROCEED_TO_CLOSE": "Weiter zum Schließen",
    "RECOMENDED_PLAYBOOK": "EMPFOHLENES PLAYBOOK",
    "PRIMARY_SCRIPTS": "PRIMÄRE SKRIPTS",
    "DYNAMIC_SCRIPTS": "DYNAMISCHE SKRIPTS",
    "RESUME": "Fortsetzen",
    "ENABLE_CLOSE": "Klicken Sie auf die Schaltfläche \"Weiter zum Schließen\", um die Schließstufe zu aktivieren.",
    "LIST_VIEW": "Listenansicht",
    "TERMINATE": "Beenden",
    "MINIMIZE": "Minimieren",
    "MAXIMIZE": "Maximieren",
    "NO_SEARCH_RESULT": "Keine Suchergebnisse gefunden",
    "SENTIMENT_AWAITING": "Warten auf Stimmung",
    "POSITIVE": "Positiv",
    "NEGATIVE": "Negativ",
    "COPY" : "Kopieren",
    "TELL_US_MORE": "Erzählen Sie uns mehr",
    "THANKS_FEEDBACK": "Danke für Ihr Feedback",
    "SOMETHING_WRONG": "Etwas ist schiefgelaufen",
    "CLICK_ERROR_DETAILS": "Klicken Sie hier für Fehlermeldungen",
    "NO_ACTIVE_PLAYBOOK": "Kein aktives Playbook",
    "REPHRASE_QUESTION": "Könnten Sie Ihre Frage umformulieren oder etwas anderes fragen?",
    "INTERNAL_INFO": "Interne Informationen",
    "SOURCES": "Quellen",
    "CONVERSATION_SUMMARY": "Gesprächszusammenfassung",
    "WAITING": "Warten",
    "WIDGET_DISABLED": "Widget deaktiviert",
    "AI_SETTINGS_DISABLED": "AI-Einstellungen sind deaktiviert! Bitte wenden Sie sich an den AI-Administrator",
    "SERVER_CONNECTION_ERROR": "Fehler beim Verbinden mit dem Server",
    "VIEW": "Anzeigen",
    "ATTACHMENT_INPUT": "Anhangseingabe",
    "TYPE_SUMMARY": "Zusammenfassung eingeben",
    "VIEW_FULL_ARTICLE_2": "Vollen Artikel anzeigen",
    "VIEW_FULL_FILE_2": "Vollen Datei anzeigen",
    "BY":"Von",
    GENERATE_SUMMARY: "Zusammenfassung erstellen",
    PREV_SUMMARIES: "Tidligere genererede resuméer",
    DIALOG_WORKFLOWS: "Dialog-Workflows",
    SHOW_ALL_DIALOG: "Alle Dialog-Aufgaben anzeigen",
    SHOW_ALL_DIALOGS: "Alle Dialoge anzeigen",
    CUSTOM_TAB: "Benutzerdefinierte Registerkarte",
    AGENT_INPUT: "Agenteneingabe",
    "CUSTOM_EMPTY_MSG" : "Kein aktiver Workflow vorhanden",
    "CUSTOM_TAB_DESC" : "Um einen Workflow zu starten, führen Sie einen aus der Liste aus, die am unteren Rand des Bildschirms angezeigt wird.",
    "SUBMIT_OVERALL_FEEDBACK" : "Gesamtes Feedback einreichen",
    "FEEDBACK_POPUP_SUBTITLE" : "Feedback über das Widget und seine Funktionen",
    "FEEDBACK_SATISFIED" : "Zufrieden",
    "FEEDBACK_UNSATISFIED" : "Nicht zufrieden",
    "FEEDBACK_PROVIDE_REASONS" : "Geben Sie mehr Informationen…",
    "FEEDBACK_TITLE" : "Feedback",
    "AGENTIC_THINKING" : "Denken",
    "AGENTIC_AGENT_TITLE" : "Agent",
    "AGENTIC_COPILOT_MODE_TITLE" : "Agentic Copilot-Modus",
    "AGENTIC_SENDING_MESSAGE" : "Wird gesendet...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot hört aktiv Ihrem Gespräch zu und ist bereit, automatisch zu assistieren",
    "AGENTIC_SEARCH_RESULTS" : "Agentische Ergebnisse",
    "PAUSE_AUTO_SEND" : "Automatisches Senden pausieren",
    "PAUSE_AGENTIC" : "Agentisch pausieren",
    "RESUME_AGENTIC" : "Agentisch fortsetzen",
    "RESUME_AUTO_SEND" : "Automatisches Senden fortsetzen"
}